import type { AnchorHTMLAttributes, ReactNode, Ref } from 'react'
import styles from './bottom-nav.module.css'
import { cx } from './cx'

/** Чёрная пилюля навигации. Не показывается в мастере и на экранах-результатах. */
export function BottomNav({ children, label = 'Разделы' }: { children: ReactNode; label?: string }) {
  return (
    <nav aria-label={label} className={styles.nav}>
      {children}
    </nav>
  )
}

export type NavItemProps = AnchorHTMLAttributes<HTMLAnchorElement> & { ref?: Ref<HTMLAnchorElement> }

/** Пункт навигации: оборачивается `createLink` роутера, активный получает оранжевую точку. */
export function NavItem({ className, ...rest }: NavItemProps) {
  return <a className={cx(styles.item, className)} {...rest} />
}
